<template>
  <div>
    <Header />
    <Breadcrumbs title="SHOP" subTitle="REWARD HISTORY" />
    <section class="loading-container" v-if="!reward_history">
      <img
        :src='require("@/assets/images/ajax-loader.gif")'
        class="img-fluid bg-img"
      />
    </section>

    <section class="section-b-space">
      <div class="container">
        <table class="table cart-table table-striped table-responsive-xs mt-4">
          <thead class="table-head">
            <tr>
              <th>Order ID</th>
              <th>Quantity</th>
              <th>Product Name</th>
              <th>Total Points</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody class="orderhistory-table-body">
            <tr v-for="reward in reward_history" v-bind:key="reward.reward_order_id">
              <td>{{reward.reward_order_id}}</td>
              <td>{{reward.quantity}}</td>
              <td>{{reward.productname}}</td>
              <td>{{reward.points_used}}</td>
              <td>{{formatDate(reward.order_date)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/header'
import Breadcrumbs from '@/components/widgets/cart-breadcrumbs'
import * as api from '@/api'

export default {
  data() {
    return {
    }
  },
  components: {
    Header,
    Breadcrumbs
  },
  computed: {
    ...mapGetters({
      reward_history:'cart/reward_history',
      getAuth: 'auth/getAccessToken',
      webTotalTitle: 'cart/webTotalTitle'
    })
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return date.toLocaleDateString(undefined, options);
    },
  },
  async mounted() {
    var  {dispatch} = this.$store
    var rewardhistory = await api.rewardHistory({limit:50},{'authorization':this.getAuth})
    dispatch('cart/setRewardhistory', rewardhistory)
  }

}
</script>
